import { render, staticRenderFns } from "./SQuesNine.vue?vue&type=template&id=08654ada&scoped=true&"
import script from "./SQuesNine.vue?vue&type=script&lang=js&"
export * from "./SQuesNine.vue?vue&type=script&lang=js&"
import style0 from "./SQuesNine.vue?vue&type=style&index=0&id=08654ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08654ada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
